<div *ngIf="logs.length === 0" style="padding: 10px">
	{{ 'FLIGHTS.CHECKIN_LOG.empty' | translate | capitalize }}
</div>
<div *ngIf="logs.length > 0" style="display: flex; flex-direction: column; gap: 6px; padding: 10px">
	<div *ngFor="let log of logs" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center">
		<span style="white-space: nowrap">{{ log.date | formatDate: 'DD MMM YY HH:mm' }}</span>
		<span style="font-weight: 500" class="notranslate">{{ log.user }}</span>
		<span *ngIf="log.section !== signoffSection">
			{{ labelKey(log.parameter) | translate | capitalize
			}}<ng-container *ngIf="log.passengerName">
				(<span class="notranslate">{{ log.passengerName }}</span
				>)</ng-container
			>: {{ log.oldValue ?? '—' }} → {{ log.newValue ?? '—' }} {{ unit(log.parameter) }}
		</span>
		<ng-container *ngIf="log.section === signoffSection">
			<span *ngIf="log.newValue === 'signed'">{{ 'FLIGHTS.CHECKIN_LOG.signoff_signed' | translate | capitalize }}</span>
			<span *ngIf="log.newValue !== 'signed'">{{ 'FLIGHTS.CHECKIN_LOG.signoff_cleared' | translate | capitalize }}</span>
			<img *ngIf="log.signature" [src]="log.signature" alt="signature" style="height: 32px; border: 1px solid #ddd; border-radius: 4px" />
		</ng-container>
	</div>
</div>
